import { render, staticRenderFns } from "./TextButtons.vue?vue&type=template&id=ec5bc97c"
import script from "./TextButtons.vue?vue&type=script&lang=js"
export * from "./TextButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports